import styled, { css } from 'styled-components'

import * as colors from '../constants/colors'
import * as copy from './copy'

export type WrapperProps = { isActive?: boolean }

export const Wrapper = styled.button<WrapperProps>`
  ${copy._smallStyle}
  background-color: transparent;
  border-color: ${colors.GREY_SHADE_5};
  border-radius: 19px;
  border-style: solid;
  border-width: 1px;
  color: ${colors.GREY_SHADE_2};
  cursor: pointer;
  display: inline-block;
  padding: 0px 8px 2px;
  transition-duration: 300ms;

  &:disabled {
    background-color: ${colors.GREY_SHADE_6};
    color: ${colors.GREY_SHADE_3};
    cursor: not-allowed;

    ${({ isActive }) => {
      if (isActive)
        return css`
          border-color: ${colors.GREY_SHADE_2};
        `
      if (!isActive)
        return css`
          border-color: ${colors.GREY_SHADE_6};
        `
    }}
  }

  &:hover {
    border-color: ${colors.PRIMARY_BLUE_HOVER};
    color: ${colors.PRIMARY_BLUE_HOVER};

    &:disabled {
      color: ${colors.GREY_SHADE_3};

      ${({ isActive }) => {
        if (isActive)
          return css`
            border-color: ${colors.GREY_SHADE_2};
          `
        if (!isActive)
          return css`
            border-color: ${colors.GREY_SHADE_6};
          `
      }}
    }
  }

  ${({ isActive }) => {
    if (isActive) {
      return css`
        border-color: ${colors.PRIMARY_BLUE};
        color: ${colors.PRIMARY_BLUE};
      `
    }
  }}
`
